module.exports = __webpack_public_path__ + "img/title3.4c28071c.png";